import { createActionWithPayload } from 'actions/utils';

export const ACTIONS = {
  SET_CURRENT_SHEET_ITEM: 'SET_CURRENT_SHEET_ITEM',
  RESET_CURRENT_SHEET_ITEM: 'RESET_CURRENT_SHEET_ITEM',
} as const;

export const setCurrentElement = createActionWithPayload<
  typeof ACTIONS.SET_CURRENT_SHEET_ITEM,
  { currentEleResponseId: string }
>(ACTIONS.SET_CURRENT_SHEET_ITEM);

export const resetCurrentElement = createActionWithPayload<
  typeof ACTIONS.RESET_CURRENT_SHEET_ITEM,
  { currentEleResponseId: string }
>(ACTIONS.RESET_CURRENT_SHEET_ITEM);
